import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IPromosEcommerce } from './../../../private/shared/models/productos';

@Component({
  selector: 'getm-promo-info-modal',
  templateUrl: './promo-info-modal.page.html',
  styleUrls: ['./promo-info-modal.page.scss']
})
export class PromoInfoModalPage implements OnInit {

  @Input() promo: IPromosEcommerce = {} as IPromosEcommerce;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit(): void { }

  public onClose = () => this.modalCtrl.dismiss(false);

}
